var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4868 13.2649L0.841651 1.43555C0.730402 1.73221 0.619141 2.02887 0.619141 2.43678V24.2043C0.619141 24.6122 0.730402 24.9089 0.841651 25.2056L13.4868 13.2649Z",
    fill: "#E95D05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9707 13.2628L19.1981 17.1936L23.8335 14.7461C25.3168 13.9674 25.3168 12.6695 23.8335 11.8907L19.0869 9.33203L14.9707 13.2628Z",
    fill: "#E95D05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2331 12.5592L18.1268 8.81383L3.25661 0.95229C2.62621 0.655628 1.9958 0.54438 1.58789 0.766876L14.2331 12.5592Z",
    fill: "#E95D05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2331 13.9312L1.58789 25.8347C1.9958 26.0201 2.6262 25.946 3.36786 25.6493L18.3122 17.7878L14.2331 13.9312Z",
    fill: "#E95D05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreIcon);
export default __webpack_public_path__ + "static/media/play-store-icon.5a19028fecc9c66b9f50d438b0357865.svg";
export { ForwardRef as ReactComponent };